export function isInFlutterWebview(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof (window as unknown as { flutter_inappwebview?: unknown }).flutter_inappwebview !==
      'undefined'
  )
}
